import { all } from "redux-saga/effects";
import { boMonSaga } from "./boMonSaga";
import { chuyenNganhSaga } from "./chuyenNganhSaga";
import { coSoSaga } from "./coSoSaga";
import { giaoVienSaga } from "./giaoVienSaga";
import { heSaga } from "./heSaga";
import { khoaSaga } from "./khoaSaga";
import { lopNamHocSaga } from "./lopNamHocSaga";
import { monHocSaga } from "./monHocSaga";
import { nganhSaga } from "./nganhSaga";
import { nhomLopSaga } from "./nhomLopSaga";
import { nhomLopSinhVienSaga } from "./nhomLopSinhVienSaga";
import { phongHocSaga } from "./phongHocSaga";
import { tangNhaSaga } from "./tangNhaSaga";
import { toaNhaSaga } from "./toaNhaSaga";
import { monTuongDuongSaga } from "./monTuongDuongSaga";
import { phongHocTrongKySaga } from "./phongHocTrongKySaga";
import { lopSaga } from "./lopSaga";
import { hinhThucGiangSaga } from "./hinhThucGiangSaga";
import { dmLoaiDangKyHocSaga } from "./dmLoaiDangKyHocSaga";
import { dmLoaiLopTinChiSaga } from "./dmLoaiLopTinChiSaga";
import { ngayNghiLeSaga } from "./ngayNghiLeSaga";
import { quyDinhSoBuoiTrenTuanSaga } from "./quyDinhSoBuoiTrenTuanSaga";
import { thoiGianHocLopHCSaga } from "./thoiGianHocLopHCSaga";
import { heSoUuTienTKBSaga } from "./heSoUuTienTKBSaga";
import { loaiGioHocSaga } from "./loaiGioHocSaga";
import { gioHocRangBuocSaga } from "./gioHocRangBuocSaga";
import { mlThamSoPhongHocMonHocSaga } from "./mlThamSoPhongHocMonHocSaga";
import { phongBanSaga } from "./phongBanSaga";
import { phongUuTienBuoiSaga } from "./phongUuTienBuoiSaga";
import { phongUuTienNhomSaga } from "./phongUuTienNhomSaga";
import { giangVienBanSaga } from "./giangVienBanSaga";
import { lopBanSaga } from "./lopBanSaga";
import { doiTuongDaoTaoSaga } from "./doiTuongDaoTaoSaga";
import { gioiTinhSaga } from "./gioiTinhSaga";

export default function* categorySagaWrapper() {
  yield all([
    nganhSaga(),
    chuyenNganhSaga(),
    heSaga(),
    lopNamHocSaga(),
    lopSaga(),
    nhomLopSaga(),
    nhomLopSinhVienSaga(),
    monHocSaga(),
    khoaSaga(),
    boMonSaga(),
    giaoVienSaga(),
    coSoSaga(),
    phongHocSaga(),
    tangNhaSaga(),
    toaNhaSaga(),
    monTuongDuongSaga(),
    phongHocTrongKySaga(),
    hinhThucGiangSaga(),
    dmLoaiDangKyHocSaga(),
    dmLoaiLopTinChiSaga(),
    ngayNghiLeSaga(),
    quyDinhSoBuoiTrenTuanSaga(),
    thoiGianHocLopHCSaga(),
    heSoUuTienTKBSaga(),
    loaiGioHocSaga(),
    gioHocRangBuocSaga(),
    mlThamSoPhongHocMonHocSaga(),
    phongBanSaga(),
    phongUuTienBuoiSaga(),
    phongUuTienNhomSaga(),
    giangVienBanSaga(),
    lopBanSaga(),
    doiTuongDaoTaoSaga(),
    gioiTinhSaga(),
  ]);
}
